import * as Msdyn365 from '@msdyn365-commerce/core';
import { ErrorCode } from '../modules/order-details';
import { ensureAuthenticated } from '../utilities/is-authenticated';

/**
 * GetDirectLineToken Input Action
 */
export class GetDirectLineTokenInput implements Msdyn365.IActionInput {
    public userToken: string;
    public timestamp: string;
    constructor(ctx: Msdyn365.ICreateActionContext) {
        this.userToken = ctx.requestContext.user.token;
        this.timestamp = new Date().getTime().toString();
    }

    public getCacheKey = () => `GetDirectLineToken-${this.userToken}-${this.timestamp}`;
    public getCacheObjectType = () => 'GetDirectLineToken';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetDirectLineTokenData {
    '@odata.context'?: string;
    value: IDirectLineToken;
    error?: ErrorCode;
}

interface IDirectLineToken {
    DirectLineToken: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetDirectLineTokenInput(args);
};

async function action(_: GetDirectLineTokenInput, ctx: Msdyn365.IActionContext): Promise<IGetDirectLineTokenData> {
    ensureAuthenticated(ctx);
    const response = await Msdyn365.sendRequest<IGetDirectLineTokenData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetDirectLineToken`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );

    if (response.status === 200 && response.data) {
        return { ...response.data };
    }
    return { ...({} as IGetDirectLineTokenData), error: { errorCode: response.status, errorText: response.statusText } };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetDirectLineTokenData>>action,
    id: 'GetDirectLineToken',
    input: createInput
});
